<template>
  <div class="col-md-4 col-sm-6 dashboard-item">
    <div class="card bg">
        <div class="text-primary pt-4 pb-4">
          <tutorial v-if="tutorials" :tutorials="tutorials"></tutorial>
        </div>
    </div>
  </div>
</template>

<script>
import Tutorial from './shared/tutorial'
export default {
  name: 'tutorials',
  components: { Tutorial },
  data () {
    return {
      tutorials: []
    }
  },
  methods: {
    getTutorials () {
      this.$store.dispatch('getSnippet', 'tutorials').then(response => {
        const allTutorials = JSON.parse(response)
        const welcomeTutorials = allTutorials.filter(data => data.category === 'Welcome')
        this.tutorials = welcomeTutorials.sort((a, b) => (a.order < b.order) ? -1 : 1)
        this.$store.commit('setTutorials', allTutorials)
        this.$emit('clicked', 'tutorial page')
      })
    }
  },
  mounted () {
    this.getTutorials()
  }
}
</script>
